<table border="1" cellpadding="8" style="width: 100%; border-collapse: collapse;">
  <tr style="text-align: center;">
    <th style="padding: 5px; border: 1px solid #000000;">Type</th>
    <th style="padding: 5px; border: 1px solid #000000;">Date</th>
    <th style="padding: 5px; border: 1px solid #000000;">Doc #/Desc</th>
    <th style="padding: 5px; border: 1px solid #000000;">Outstanding</th>
    <th style="padding: 5px; border: 1px solid #000000;">Amount</th>
    <th style="padding: 5px; border: 1px solid #000000;">Payment</th>
  </tr>
  @if (knockoffItems?.length) {
  @for (item of knockoffItems; track item) {
  <tr style="border: 1px solid #000000">
    <td style="text-align: center; border: 1px solid #000000;">{{ item.type }}</td>
    <td style="text-align: center; border: 1px solid #000000;">{{ item.date }}</td>
    <td style="line-height: 16px; border: 1px solid #000000;">
      <div style="font-weight: 600; font-size: 14px; color: #08306B;">{{ item.docNo }}</div>
      <div style="font-size: 12px;">{{ item.description }}</div>
    </td>
    <td style="font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.outstanding | price }}</td>
    <td style="font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.amount | price }}</td>
    <td style="font-weight: 500; font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.payment | price }}</td>
  </tr>
  }
  }
  @else {
  <tr>
    <td colspan="6" style="text-align: center; padding: 12px; border: 1px solid #000000;">No knockoff records available.</td>
  </tr>
  }
</table>

<div style="display: flex; margin: 12px 0 24px; padding-left: 20px; padding-right: 35px; line-height: 24px;">
  <div style="margin-left: auto; font-weight: 600; font-size: 14px;">
    <table cellpadding="0">
      <tr>
        <td style="text-align: right;"><b>UNMATCHED AMOUNT</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{ currencyCode }}
          {{ unmatchedAmount | number: '1.2-2' }}</td>
      </tr>
    </table>
  </div>
</div>

<!-- <table border="1" cellpadding="8" style="width: 100%; border-collapse: collapse;">
  <tr style="text-align: center;">
    <th style="padding: 5px; border: 1px solid #000000;">#</th>
    <th style="padding: 5px; border: 1px solid #000000;">Account</th>
    <th style="padding: 5px; border: 1px solid #000000;">Account Name</th>
    <th style="padding: 5px; border: 1px solid #000000;">Description</th>
    <th style="padding: 5px; border: 1px solid #000000;">Amount</th>
  </tr>
  @if (accountItems?.length) {
  @for (item of accountItems; track item; let index = $index) {
  <tr style="border: 1px solid #000000">
    <td style="text-align: center; border: 1px solid #000000;">{{ index + 1 }}</td>
    <td style="text-align: center; border: 1px solid #000000;">{{ item.accountCode }}</td>
    <td style="line-height: 16px; border: 1px solid #000000;">{{ item.accountName }}</td>
    <td style="line-height: 16px; border: 1px solid #000000;">{{ item.description }}</td>
    <td style="font-weight: 500; font-size: 13px; text-align: end; border: 1px solid #000000;">{{ item.amount | price }}</td>
  </tr>
  }
  <tr style="font-weight: 600;">
    <td colspan="4" style="text-align: right; padding: 8px 12px; border: 1px solid #000000;">Total</td>
    <td style="text-align: end; padding: 8px 12px; border: 1px solid #000000;">{{ accountTotal | price }}</td>
  </tr>
  }
  @else {
  <tr>
    <td colspan="5" style="text-align: center; padding: 12px; border: 1px solid #000000;">No account entries available.</td>
  </tr>
  }
</table>

<div style="display: flex; margin-top: 10px; padding-left: 20px; padding-right: 35px; line-height: 24px;">
  <div style="margin: 0 0 0 auto;">
    <table cellpadding="0">
      <tr>
        <td style="text-align: right;"><b>TAXABLE AMOUNT</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{ currencyCode }}
          {{ taxableAmount | number: '1.2-2' }}</td>
      </tr>
      <tr>
        <td style="text-align: right;"><b>TAX</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{ currencyCode }}
          {{ taxAmount | number: '1.2-2' }}</td>
      </tr>
      <tr>
        <td style="text-align: right;"><b>NET TOTAL</b></td>
        <td style="text-align: right; font-weight: 500; padding-left: 20px;">{{ currencyCode }}
          {{ netTotal | number: '1.2-2' }}</td>
      </tr>
    </table>
  </div>
</div> -->
